import React from 'react'
import { makeStyles } from '@material-ui/styles'
import IconAndText from 'components/common/IconAndText'
import PinnedNotesButtonIcon from './PinnedNotesButtonIcon'
import DazzedParagraph12 from 'components/common/text/DazzedParagraph12'

const useStyles = makeStyles(theme => ({
  pinnedNotesButtonRoot: {
    backgroundColor: 'rgba(242, 243, 255, 1)',
    padding: '4px 10px',
    userSelect: 'none',
    borderRadius: 70
  },
  label: {
    fontSize: 13,
    color: 'rgba(60, 82, 239, 1)'
  }
}))

const PinnedNotesTriggerButton = ({ count }) => {
  const classes = useStyles()

  return (
    <div className={classes.pinnedNotesButtonRoot}>
      <IconAndText
        icon={<PinnedNotesButtonIcon />}
        text={
          <DazzedParagraph12 className={classes.label} thickness="strong">
            {count}
          </DazzedParagraph12>
        }
        reverse
      />
    </div>
  )
}

export default PinnedNotesTriggerButton
